import { keyBy } from 'lodash';
import classnames from 'classnames';

import classes from './SettingsSelectSolution.module.scss';

const SettingsSelectSolution = ({
  solutionLists,
  value,
  onChange,
  translate,
  solutions,
  solutionLocale,
  mobileRuntime = false,
}) => {
  const solutionsMap = keyBy(solutions, '_id');
  const singleList = Array.isArray(solutionLists) && solutionLists.length === 1;

  const uiLocale =
    solutionLocale?.code ||
    translate?.getLocale?.() ||
    translate?.currentLocale ||
    translate?.locale ||
    'unknown';

  console.log('SettingsSelectSolution init:', {
    uiLocale,
    solutionListsCount: Array.isArray(solutionLists) ? solutionLists.length : 'n/a',
  });

  return (
    <div className={classnames(classes.listsWrapper, {
      [classes.mobileRuntime]: mobileRuntime,
    })}>
      {solutionLists.map((list) => {
        const labelKey = list.titleStringNumber || 940;
        const labelText = translate(labelKey, 'Modules');

        console.log('SettingsSelectSolution label debug:', {
          listId: list.id,
          rawTitleStringNumber: list.titleStringNumber,
          usedLabelKey: labelKey,
          uiLocale,
          labelText,
        });

        return (
          <div className={classnames(classes.radioListWrapper, { [classes.singleList]: mobileRuntime && singleList })} key={list.id}>
            {(!mobileRuntime || !singleList) && (
              <p className={classes.radioListLabel}>
                {labelText}
              </p>
            )}

            <div className={classes.radioList}>
              {list.items.map((solutionId) => {
                const solution = solutionsMap[solutionId];
                if (!solution) return null;

                return (
                  <label key={solutionId}>
                    <input
                      checked={solutionId === value}
                      value={solutionId}
                      onChange={() => onChange(solutionId)}
                      type="radio"
                    />
                    <span>{solution.displayName}</span>
                  </label>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SettingsSelectSolution;
